import { ButtonHTMLAttributes, forwardRef } from "react";
import clsx from "clsx";

type Variant = "primary" | "yellow" | "secondary" | "ghost" | "danger";
type Size = "default" | "small";

type Props = ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: Variant;
  size?: Size;
  block?: boolean;
};

export const Button = forwardRef<HTMLButtonElement, Props>(function Button(
  { variant = "primary", size = "default", block, className, type = "button", ...rest },
  ref,
) {
  return (
    <button
      ref={ref}
      type={type}
      className={clsx(
        "tcg-btn",
        variant === "primary" && "tcg-btn-primary",
        variant === "yellow" && "tcg-btn-yellow",
        variant === "secondary" && "tcg-btn-secondary",
        variant === "ghost" && "tcg-btn-ghost",
        variant === "danger" && "tcg-btn-danger",
        size === "small" && "tcg-btn-small",
        block && "tcg-btn-block",
        className,
      )}
      {...rest}
    />
  );
});
